// extracted by mini-css-extract-plugin
export var component = "ContentNodeTeaser-module--component--xxp6D";
export var excerpt = "ContentNodeTeaser-module--excerpt--ekHLz";